"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// "analytics" is obtained from the service analytics file, which is global for the service
// namespace for shared analytics integrations
var sharedAnalyticsIntegrations = {};
sharedAnalyticsIntegrations.isMobile = function (iPhoneOnly, excludeTablet, customUserAgentData) {
  var agentStyles;
  if (customUserAgentData || global.navigator) {
    if (iPhoneOnly) {
      agentStyles = /iPhone/i.test(customUserAgentData || global.navigator.userAgent);
    } else if (excludeTablet) {
      agentStyles = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(customUserAgentData || navigator.userAgent);
    } else {
      agentStyles = /Android.+Mobile|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(customUserAgentData || global.navigator.userAgent);
    }
  }
  var isMobile = agentStyles;
  return isMobile;
};

// checks segment state
sharedAnalyticsIntegrations.segmentLoaded = function () {
  return !!analytics;
};
var _default = exports.default = sharedAnalyticsIntegrations;